var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPitchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type=Pitch"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2276 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 5.5H1.5V18.5H22.5V5.5ZM1.5 4C0.671573 4 0 4.67157 0 5.5V18.5C0 19.3284 0.671573 20 1.5 20H22.5C23.3284 20 24 19.3284 24 18.5V5.5C24 4.67157 23.3284 4 22.5 4H1.5Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2388 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 9.5H1.5V14.5H3.5V9.5ZM0 8V16H5V8H0Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2389 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 9.5H20.5V14.5H22.5V9.5ZM19 8V16H24V8H19Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 356 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 19.5V4.5H12.75V19.5H11.25Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1082",
    cx: 12,
    cy: 12,
    r: 2,
    fill: "#111111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitchIcon);
export default __webpack_public_path__ + "static/media/PitchIcon.f20df9db67ca92cb047c559d8711d332.svg";
export { ForwardRef as ReactComponent };